export default {"src":"/_next/static/media/dark-grey-left.c5062eb0.svg","height":220,"width":1920,"blurWidth":0,"blurHeight":0};